import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Button from 'antd/lib/button';
import message from 'antd/lib/message';
import BookOutlined from '@ant-design/icons/BookOutlined';
import React, { useContext, useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../api/axiosCall';
import CommonLayout from '../../common/CommonLayout';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../../constant/constants';
import { AuthContext } from '../../context/AuthProvider';

function TermsAndCondition() {
  const [termsAndCondition, setTermsAndCondition] = useState('');
  const [updatedTermsAndCondition, setUpdatedTermsAndCondition] = useState('');

  const { token } = useContext(AuthContext);

  useEffect(() => {
    getTermsAndCondition();
  }, []);

  async function getTermsAndCondition() {
    try {
      const res = await axiosGetCall({
        apiEndPoint: API_END_POINT.GET_TERMS_AND_CONDITION,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.hideErrorFromUser) {
        setTermsAndCondition(res.data.content);
      } else {
        message.error(SOMETHING_WENT_WRONG);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  const handleCancelClick = () => {
    getTermsAndCondition();
  };

  const handleSaveClick = async () => {
    try {
      const res = await axiosPostCall({
        apiEndPoint: API_END_POINT.UPDATE_TERMS_AND_CONDITION,
        header: { Authorization: `Bearer ${token}` },
        body: {
          content: updatedTermsAndCondition,
          loggedInUser: 'string',
        },
      });
      if (res.hideErrorFromUser) {
        getTermsAndCondition();
        message.success(res.data);
        return;
      } else {
        message.error(res?.error?.message);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  };

  return (
    <CommonLayout>
      <div className='flex flex-col w-full p-6'>
        <div className='bg-surface border border-border rounded-xl shadow p-4'>
          <div className='w-full'>
            <CKEditor
              editor={ClassicEditor}
              data={termsAndCondition}
              config={{
                toolbar: [
                  'bold',
                  'italic',
                  'underline',
                  'strikethrough',
                  '|',
                  'link',
                  '|',
                  'undo',
                  'redo',
                ],
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setUpdatedTermsAndCondition(data);
              }}
            />
          </div>

          <div className='flex justify-end gap-3 mt-4'>
            <Button
              onClick={() => handleCancelClick()}
              className='w-28 bg-surface border border-border text-text hover:text-primary hover:border-primary'
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleSaveClick()}
              type='primary'
              className='w-36 border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
            >
              Save Changes
            </Button>
          </div>
        </div>
      </div>
    </CommonLayout>
  );
}

export default TermsAndCondition;
